const Header = () => {
  return (
    <header>
      <h1>⚽ Football-App ⚽</h1>
      <p>Les classements et équipes des plus grands championnats de football</p>
    </header>
  );
};

export default Header;
